export const staticTocFlow = {
  flowName: 'TABLE OF CONTENTS',
  style: {
    width: 794,
    height: 1123,
    backgroundColor: '#ffffff',
    padding: {
      left: 76,
      right: 76,
      bottom: 0,
      top: 20,
    },
    pageNumber: {
      contents: {
        style: {
          x: 0,
          y: 0,
          width: 60,
          height: 24,
        },
        isDeleted: false,
        isStandalone: false,
        isTranslated: false,
      },
      ofText: 'of',
    },
    fontSize: 20,
  },
  isDeleted: false,
  paperSize: 'a4',
  paperOrientation: 'portrait',
  blocks: [
    {
      blockType: 'text',
      orderNumber: 1,
      variableContract: [],
      style: {},
      contents: [
        {
          content: 'TABLE OF CONTENTS',
          contentType: 'PARAGRAPH',
          style: {
            fontSize: 30,
            color: '#000000',
          },
        },
        {
          content: '\n',
          contentType: 'LINE_BREAK',
          style: {
            alignment: 'center',
            lineSpacing: 1.5,
            indent: 0,
            fontSize: 30,
          },
        },
        {
          content: '\n',
          contentType: 'LINE_BREAK',
          style: {
            alignment: 'left',
            lineSpacing: 1.5,
            indent: 0,
          },
        },
        {
          content: '\n',
          contentType: 'LINE_BREAK',
          style: {
            alignment: 'left',
            lineSpacing: 1.5,
            indent: 0,
          },
        },
      ],
      isDeleted: false,
      isStandalone: false,
      blockDTOList: [],
      isTranslated: false,
    },
    // {
    //   blockId: 'dummyBlock-1',
    //   blockType: 'text',
    //   orderNumber: 3,
    //   variableContract: [],
    //   style: {},
    //   contents: [
    //     {
    //       content: 'Title- 1...............................................................................................03',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 20,
    //         fontWeight: ['bold'],
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //         textTransform: 'uppercase',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: '    Section- 1............................................................................................................03',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 18,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 1.................................................................................................................04',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 2.................................................................................................................06',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: '    Section- 2............................................................................................................08',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 18,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 1.................................................................................................................08',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 2.................................................................................................................10',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 3.................................................................................................................18',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: 'Title- 2...............................................................................................20',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 20,
    //         fontWeight: ['bold'],
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //         textTransform: 'uppercase',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: '    Section- 1............................................................................................................20',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 18,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 1.................................................................................................................21',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 2.................................................................................................................24',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 3.................................................................................................................27',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: '    Section- 2............................................................................................................32',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 18,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 1.................................................................................................................33',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 2.................................................................................................................38',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 3.................................................................................................................41',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 4.................................................................................................................43',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: 'Title- 3...............................................................................................45',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 20,
    //         fontWeight: ['bold'],
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //         textTransform: 'uppercase',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: '    Section- 1............................................................................................................46',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 18,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 1.................................................................................................................47',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 2.................................................................................................................50',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 3.................................................................................................................53',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: '    Section- 2............................................................................................................55',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 18,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 1.................................................................................................................58',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 2.................................................................................................................60',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 3.................................................................................................................62',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: '    Section- 3............................................................................................................65',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 18,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 1.................................................................................................................66',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 2.................................................................................................................69',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 3.................................................................................................................70',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: '    Section- 4............................................................................................................72',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 18,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 1.................................................................................................................75',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 2.................................................................................................................79',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 3.................................................................................................................82',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: 'Title- 4...............................................................................................85',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 20,
    //         fontWeight: ['bold'],
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //         textTransform: 'uppercase',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: '    Section- 1............................................................................................................86',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 18,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 1 ................................................................................................................88',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 2.................................................................................................................90',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: '',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '    Section- 2............................................................................................................92',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 18,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 1.................................................................................................................95',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 2.................................................................................................................97',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content: '    Section- 3..........................................................................................................100',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 18,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 1...............................................................................................................101',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 2...............................................................................................................103',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //     {
    //       content:
    //         '        Sub-section- 3...............................................................................................................105',
    //       contentType: 'PARAGRAPH',
    //       style: {
    //         fontSize: 16,
    //         color: '#000000',
    //         backgroundColor: '#00000000',
    //       },
    //     },
    //     {
    //       content: '\n',
    //       contentType: 'LINE_BREAK',
    //       style: {
    //         alignment: 'left',
    //         lineSpacing: 1.5,
    //         indent: 0,
    //       },
    //     },
    //   ],
    //   isDeleted: false,
    //   isStandalone: false,
    //   blockDTOList: [],
    //   isTranslated: false,
    // },
  ],
  isStandalone: false,
  isTranslated: false,
  isHeaderStandalone: false,
  isFooterStandalone: false,
};
